<template>
  <div
    class="min-w-0 rounded-xl border border-slate-200/70 bg-white p-4 shadow-sm transition-colors duration-200 hover:border-slate-300"
    :class="{ 'border-rose-200 bg-rose-50/30': metric.error }"
  >
    <div class="min-w-0">
      <div class="min-w-0">
        <p class="truncate text-sm font-medium text-slate-900">{{ metric.title }}</p>
        <p class="mt-0.5 truncate text-xs text-slate-500">{{ metric.caption }}</p>
      </div>
    </div>

    <div class="mt-4 min-w-0">
      <div class="flex min-w-0 items-baseline gap-1">
        <span
          class="min-w-0 truncate text-2xl font-semibold leading-8 text-slate-950"
          :class="{ 'text-slate-400': metric.loading || metric.error }"
        >
          {{ metric.value }}
        </span>
        <span v-if="metric.valueLabel" class="shrink-0 text-xs font-medium text-slate-500">{{ metric.valueLabel }}</span>
      </div>
      <div class="mt-3 flex min-w-0 items-center justify-between gap-2">
        <span class="truncate text-xs text-slate-500">{{ metric.subText }}</span>
        <span
          class="shrink-0 rounded-full px-2 py-0.5 text-xs font-medium"
          :class="trendClass"
        >
          {{ metric.growthText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  metric: {
    type: Object,
    required: true
  }
})

const trendClass = computed(() => {
  if (props.metric.error) return 'bg-rose-100 text-rose-700'
  if (props.metric.trend === 'up') return 'bg-emerald-50 text-emerald-700'
  if (props.metric.trend === 'down') return 'bg-rose-50 text-rose-700'
  return 'bg-slate-100 text-slate-500'
})
</script>
